var exports = {
  "kL": "xa9f3555f--72f11e--container",
  "Nr": "xa9f3555f--72f11e--card",
  "u5": "xa9f3555f--72f11e--card-multiply",
  "dI": "xa9f3555f--72f11e--card-1",
  "YZ": "xa9f3555f--72f11e--card-2",
  "Rl": "xa9f3555f--72f11e--card-3",
  "uR": "xa9f3555f--72f11e--card-gradient",
  "yz": "xa9f3555f--72f11e--mobile-dream-card",
  "v$": "xa9f3555f--72f11e--mobile-step-card",
};

module.exports = exports;
